import { render, staticRenderFns } from "./downRateXin.vue?vue&type=template&id=036e2cac&scoped=true&"
import script from "./downRateXin.vue?vue&type=script&lang=js&"
export * from "./downRateXin.vue?vue&type=script&lang=js&"
import style0 from "./downRateXin.vue?vue&type=style&index=0&id=036e2cac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e2cac",
  null
  
)

export default component.exports